import { Query } from '@datorama/akita';
import { IFaceliftState } from './IFaceliftState';
import { FaceliftStore } from './facelift.store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FaceliftQuery extends Query<IFaceliftState> {
	readonly isFaceliftEnabled$: Observable<boolean> = this.select((state) => state.isFaceliftEnabled);

	constructor(protected readonly store: FaceliftStore) {
		super(store);
	}
}
